import React, {
  Component,
  PropTypes
} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as app from '../actions/app';
import * as chat from '../actions/chat';
import App from '../components/app/';
import { WEB_RTC_FEATURES } from 'actions/chat/webrtc';

export default connect(
  state => ({
    requestError: state.app.requestError,
    mounted: state.app.mounted,
    ended: state.app.ended,
    companionAvailable: state.app.companionAvailable,
    pendingMessages: state.chat.main.pendingNotifications,
    userTimezoneOffset: state.app.userTimezoneOffset,
    chatLoading: state.chat.main.loading,
    chatStarted: state.chat.main.started,
    chatEnded: state.chat.main.ended,
    chatting: state.chat.main.chatting,
    connectionId: state.chat.main.connectionId,
    videoOngoing: state.chat.webrtc.started && state.chat.webrtc.mode !== WEB_RTC_FEATURES.audioOnly,
    isOutOfSchedule: state.app.isOutOfSchedule,
    isOutOfScheduleMessage: state.app.isOutOfScheduleMessage,
  }),
  (dispatch, ownProps) => ({
    ...bindActionCreators({
      onMount: app.mount,
      onRestore: chat.startHub.bind(null, undefined),
    }, dispatch),
    onEnd: () => {
      dispatch(app.end());
      if (ownProps && ownProps.onEnd) {
        ownProps.onEnd();
      }
    }
  })
)(App);



// WEBPACK FOOTER //
// ./containers/App.js